import { useQuery } from '@tanstack/react-query';
import { authService } from '../lib/auth';
import { apiService } from '../lib/api';

interface ChimeUser {
  id: number;
  email: string;
  username: string;
  fullName: string;
  country: string;
  profilePicture: string | null;
  userType: string;
  onboarded: boolean;
  isAdmin: boolean;
  isStaff: boolean;
  createdAt: string;
  updatedAt: string;
}

async function fetchCurrentUser(): Promise<ChimeUser> {
  const response = await apiService.request<ChimeUser>('/api/v1/user/info');
  
  // User info loaded successfully
  
  return response;
}

export const useCurrentUser = () => {
  const isAuthenticated = authService.isAuthenticated();
  
  return useQuery({
    queryKey: ['currentUser'],
    queryFn: fetchCurrentUser,
    enabled: isAuthenticated, // Only fetch when authenticated
    staleTime: 10 * 60 * 1000, // 10 minutes
    retry: 2,
  });
};